import React, { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { registerGsapPlugins, isTouchDevice } from "utils/gsap.js";
import { graphql } from "gatsby";
import { useStaticQuery } from "gatsby";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
//assets
import doodle from "assets/svg/doodle-1.svg";
import doodleCircle from "assets/gif/doodle-footer.gif";

//styles
import typographySizes from "styles/typographySizes.js";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery.js";
import colors from "styles/colors.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";
import MainWrapper from "components/global/MainWrapper.js";
import ServicesItem from "components/home/services/ServicesItem.js";
import BtnSec from "components/global/BtnSec.js";
import Body from "components/global/typography/text/Body.js";
import PlayBtn from "components/home/header/PlayBtn.js";
import Media from "components/global/Media.js";
import Works from "components/global/works/Works.js";

const Wrapper = styled.footer`
  margin-top: 10rem;
  height: 90svh;

  /* -webkit-clip-path: ellipse(70% 60% at 50% 60%);
  clip-path: ellipse(70% 60% at 50% 60%); */
  -webkit-clip-path: ellipse(60% 60% at 50% 70%);
  clip-path: ellipse(60% 60% at 50% 70%);
  background-color: ${colors.purple};

  @media all and (max-width: ${mediaQuery.tablet}) {
    height: initial !important;
    -webkit-clip-path: ellipse(80% 60% at 50% 70%);
    clip-path: ellipse(80% 60% at 50% 70%);
  }

  ${MainWrapper} {
    display: flex;
    flex-direction: column-reverse;
    gap: 20svh;
    padding-bottom: 2.4rem;

    @media all and (max-width: ${mediaQuery.tablet}) {
      gap: 0rem;
    }
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7rem;
  align-items: center;
  justify-content: center;
  @media all and (max-width: ${mediaQuery.tablet}) {
  margin: 25rem 0 11rem 0;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 2rem;

  @media all and (max-width: ${mediaQuery.tablet}) {
    flex-direction: column;
  }
`;

const Titlerapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 1 0;


  @media all and (max-width: ${mediaQuery.tablet}) {
    order: -1;
    gap: 6rem;
    margin-bottom: 3.6rem;
  }
`;

const Title = styled.h3`
  font-size: ${typographySizes.text.tekstSize7.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize7.lineHeight};
  color: ${colors.dark};
  text-align: center;
  flex: 1 1 0;
  min-width: 0;
  position: relative;



    @media all and (max-width: ${mediaQuery.desktop}) {
   
      font-size: ${typographySizes.text.tekstSize7.size.mobile}rem;
      line-height: ${typographySizes.text.tekstSize7.lineHeight};
    }

`;

const DoodleFooter = styled.img`
   position: absolute;
    bottom: 0;
    right: 30%;
    transform: translate(50%, 75%) rotate(20deg);
    z-index: -1;

width: 14rem;
`;

const StyledBtn = styled(BtnSec)`
display: none;
  &.mobile-hidden {
  display: block;
  }

  @media all and (max-width: ${mediaQuery.tablet}) {
    display: block;
    &.mobile-hidden {
      display: none;
    }
  }
`;

const Mail = styled.a`
  font-size: ${typographySizes.text.tekstSize5.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize5.lineHeight};
  color: ${colors.dark};
  flex: 1 1 0;
  min-width: 0;
  font-family: "Trash", sans-serif;
  text-align: center;

  @media all and (max-width: ${mediaQuery.desktop}) {
    font-size: ${typographySizes.text.tekstSize5.size.mobile}rem;
    line-height: ${typographySizes.text.tekstSize5.lineHeight};
  }
`;

const Subtitle = styled.h4`
  font-size: ${typographySizes.text.tekstSize5.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize5.lineHeight};
  color: ${colors.dark};
  flex: 1 1 0;
  min-width: 0;
  font-family: "Trash", sans-serif;
  text-align: center;

  @media all and (max-width: ${mediaQuery.desktop}) {
    font-size: ${typographySizes.text.tekstSize3.size.desktop}rem;
    line-height: ${typographySizes.text.tekstSize3.lineHeight};
  }
`;

const BotomLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;

`;

const SocialMedia = styled.div`
  display: flex;
  gap: 0.8rem;
  justify-content: center;
  align-items: center;
`;

const SocialMediaItem = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  padding: 0.4rem;
  border-radius: 0.2rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
  }
`;

const PagesWrapper = styled.div`
  display: flex;
  gap: 2.4rem;
  justify-content: center;
  align-items: center;
`;

const PageItem = styled(Link)`
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize1.lineHeight};
  color: ${colors.dark};
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    opacity: 0.5;
    transition: all 0.3s ease-in-out;
  }

  @media all and (max-width: ${mediaQuery.tablet}) {
    font-size: ${typographySizes.text.tekstSize1.size.mobile}rem;
    line-height: ${typographySizes.text.tekstSize1.lineHeight};
  }
`;

const FooterLink = styled.a`
  font-size: ${typographySizes.text.tekstSize0.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize0.lineHeight};
  color: ${colors.dark};
  text-align: center;
  text-decoration: none;
  transition: all 0.3s ease-in-out;


&:hover {
  opacity: 0.5;
  transition: all 0.3s ease-in-out;
  }

  @media all and (max-width: ${mediaQuery.tablet}) {
    font-size: ${typographySizes.text.tekstSize0.size.mobile}rem;
    line-height: ${typographySizes.text.tekstSize0.lineHeight};
  }
`;

// The footer box is viewport sized (100vw / 90svh) while its content is sized
// in rem, so zooming the page shrinks the ellipse around content that keeps
// its size. Both radii get scaled by the same factor until the content fits
// again: the ellipse keeps its shape and nothing gets clipped.
const clipGeometry = {
  start: { rx: 90, ry: 60, cx: 50, cy: 60 },
  desktop: { rx: 60, ry: 60, cx: 50, cy: 70 },
  tablet: { rx: 95, ry: 60, cx: 50, cy: 60 },
};

const CLIP_FIT_MARGIN = 1.04;
const CLIP_FIT_MAX_SCALE = 3;

const toClipPath = ({ rx, ry, cx, cy }) =>
  `ellipse(${rx.toFixed(2)}% ${ry.toFixed(2)}% at ${cx}% ${cy}%)`;

// Flex items are wider than the text they center, so the text/image boxes are
// measured instead of the element box.
const getInkBox = (element) => {
  const range = document.createRange();
  range.selectNodeContents(element);
  const rects = Array.from(range.getClientRects()).filter(
    (rect) => rect.width && rect.height
  );

  if (!rects.length) return element.getBoundingClientRect();

  return {
    left: Math.min(...rects.map((rect) => rect.left)),
    right: Math.max(...rects.map((rect) => rect.right)),
    top: Math.min(...rects.map((rect) => rect.top)),
    bottom: Math.max(...rects.map((rect) => rect.bottom)),
  };
};

const getContentFitScale = (footerElement, geometry) => {
  const footerRect = footerElement.getBoundingClientRect();
  const { width, height } = footerRect;
  if (!width || !height) return 1;

  const cx = (geometry.cx / 100) * width;
  const cy = (geometry.cy / 100) * height;
  const rx = (geometry.rx / 100) * width;
  const ry = (geometry.ry / 100) * height;

  let furthestCorner = 0;

  footerElement.querySelectorAll("[data-clip-fit]").forEach((element) => {
    if (!element.getClientRects().length) return;

    const box = getInkBox(element);
    const xs = [box.left - footerRect.left, box.right - footerRect.left];
    const ys = [box.top - footerRect.top, box.bottom - footerRect.top];

    xs.forEach((x) => {
      ys.forEach((y) => {
        furthestCorner = Math.max(
          furthestCorner,
          Math.hypot((x - cx) / rx, (y - cy) / ry)
        );
      });
    });
  });

  if (!furthestCorner) return 1;

  return gsap.utils.clamp(
    1,
    CLIP_FIT_MAX_SCALE,
    furthestCorner * CLIP_FIT_MARGIN
  );
};

const interpolateGeometry = (from, to, progress) => ({
  rx: gsap.utils.interpolate(from.rx, to.rx, progress),
  ry: gsap.utils.interpolate(from.ry, to.ry, progress),
  cx: gsap.utils.interpolate(from.cx, to.cx, progress),
  cy: gsap.utils.interpolate(from.cy, to.cy, progress),
});

const Footer = () => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      strapiFooter {
        Title
        Subtitle
        Mail
        Book_a_call_link
        Social_media {
          Link
          Icon {
            localFile {
              url
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  `);
  const footerRef = useRef(null);
  const location = useLocation();

  const isTabletDown = () => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(`(max-width: ${mediaQuery.tablet})`).matches;
  };

  useEffect(() => {
    const footerElement = footerRef.current;
    if (!footerElement) return;

    registerGsapPlugins();

    const ctx = gsap.context(() => {
      const targetGeometry = () =>
        isTabletDown() ? clipGeometry.tablet : clipGeometry.desktop;

      let progress = 0;
      let fitScale = 1;

      const render = () => {
        const geometry = interpolateGeometry(
          clipGeometry.start,
          targetGeometry(),
          progress
        );
        const clipPath = toClipPath({
          ...geometry,
          rx: geometry.rx * fitScale,
          ry: geometry.ry * fitScale,
        });

        footerElement.style.clipPath = clipPath;
        footerElement.style.webkitClipPath = clipPath;
      };

      // The scroll end state is the tightest one, so measuring it once per
      // refresh keeps the scroll itself free of layout reads.
      const measure = () => {
        fitScale = getContentFitScale(footerElement, targetGeometry());
        render();
      };

      measure();

      const trigger = ScrollTrigger.create({
        trigger: footerElement,
        start: "top bottom",
        end: "bottom bottom",
        onUpdate: (self) => {
          progress = self.progress;
          render();
        },
        onRefresh: (self) => {
          progress = self.progress;
          measure();
        },
      });

      let resizeTimeout;
      let lastWidth = window.innerWidth;
      let lastHeight = window.innerHeight;
      const onResize = () => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        const widthChanged = newWidth !== lastWidth;
        // The footer is 90svh tall, so a height change moves the content
        // inside the ellipse as well - but on touch devices height-only
        // resizes are just the address bar showing/hiding.
        const heightChanged = newHeight !== lastHeight && !isTouchDevice();
        if (!widthChanged && !heightChanged) return;
        lastWidth = newWidth;
        lastHeight = newHeight;

        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          requestAnimationFrame(() => {
            ScrollTrigger.refresh();
          });
        }, 150);
      };

      window.addEventListener("resize", onResize);

      return () => {
        clearTimeout(resizeTimeout);
        window.removeEventListener("resize", onResize);
        trigger.kill();
      };
    }, footerElement);

    const refreshId = requestAnimationFrame(() => {
      ScrollTrigger.refresh();
    });

    return () => {
      cancelAnimationFrame(refreshId);
      ctx.revert();
    };
  }, [location.pathname]);

  return (
    <Wrapper id="footer" ref={footerRef}>
      <MainWrapper>
        <BotomLinks>
          <SocialMedia data-clip-fit>
            {data.strapiFooter.Social_media.map((item, index) => (
              <SocialMediaItem
                key={index}
                href={item.Link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Media media={item.Icon} alt={item.Icon.localFile.url} />
              </SocialMediaItem>
            ))}
          </SocialMedia>
          <PagesWrapper data-clip-fit>
            <PageItem to="/">Home</PageItem>
            <PageItem to="/portfolio">Portfolio</PageItem>
            <PageItem to="/about">About</PageItem>
            <PageItem to="/services">Services</PageItem>
          </PagesWrapper>

          <FooterLink
            data-clip-fit
            href="https://we3studio.pl"
            target="_blank"
            rel="noopener noreferrer"
          >
            well designed by: we3studio.pl
          </FooterLink>
        </BotomLinks>
        <MainContent>
          <TextWrapper>
            <Mail data-clip-fit href={`mailto:${data.strapiFooter.Mail}`}>
              {data.strapiFooter.Mail}
            </Mail>
            <Titlerapper>
              <Title data-clip-fit>
                {data.strapiFooter.Title}{" "}
                <DoodleFooter src={doodleCircle} alt="" aria-hidden="true" />
              </Title>
              <StyledBtn
                data-clip-fit
                href={data.strapiFooter.Book_a_call_link}
              >
                Book a call
              </StyledBtn>
            </Titlerapper>
            <Subtitle data-clip-fit>
              <TextWithLineBreaks text={data.strapiFooter.Subtitle} />
            </Subtitle>
          </TextWrapper>
          <StyledBtn
            data-clip-fit
            className="mobile-hidden"
            href={data.strapiFooter.Book_a_call_link}
          >
            Book a call
          </StyledBtn>
        </MainContent>
      </MainWrapper>
    </Wrapper>
  );
};

export default Footer;
